import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux';

import { s3LoadUrl } from '../../helper/s3LoadUrl';
import { Close } from '../../static';
import { hidePopup} from '../../app/actions/uiActions';

import './styles.scss';

const PopUp = () => {
	const dispatch = useDispatch();
	const popup = useSelector((state) => state.ui.popup);
	const [url, setUrl] = useState(() => '');
	
	const handleClick = () => {
		dispatch(hidePopup());
	};

	useEffect(() => {
		if(popup.imgId) {
			const url = s3LoadUrl(popup.imgId);
			setUrl(url);
		} else {
			setUrl('');
		}

	},[popup]);

	const stopPropagation = (e) => {
		e.preventDefault()
		e.stopPropagation();
	};

	return (
		<>
		{popup.active && (
			<div className="popup" onClick={handleClick}>
				<div 
					className="popup__close"
					onClick={handleClick}
				>
					<Close />
				</div>

				<div className="popup__img"
					onClick={stopPropagation}
				>
				{url.includes('pdf') ? 
					<iframe src={url} title="myFrame"></iframe> 
						:
					 <img src={url} alt="img"/> 

				}

				</div>
			</div>
		)}
		</>
	);
};

export default PopUp;
